import { useQuery } from 'react-query'
import { initSubscription } from 'services/plan'

export default function useGetInitBanks() {
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data, isLoading } = useQuery(
        ['init-subscription', profile?.id],
        initSubscription
    )
    return { data, isLoading }
}
